/* */ 
module.exports = require('./_shared')('native-function-to-string', Function.toString);
